/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

type Props = {
  title?: React.ReactNode;
  children: React.ReactNode;
  spacing?: number;
};

const styles = {
  subsection: (spacing?: number) => css`
    padding: ${spacing ? `${spacing}px` : 'var(--cds-spacing-200)'} 0 var(--cds-spacing-200);
  `,
  subsectionTitle: css`
    margin-bottom: var(--cds-spacing-200);
  `,
};

const Subsection = ({ title, children, spacing }: Props) => {
  return (
    <div css={styles.subsection(spacing)}>
      {title && <div css={styles.subsectionTitle}>{title}</div>}
      {children}
    </div>
  );
};

export default Subsection;
